import http from '@services/http';
import { ILikeable } from 'types/likes';
import { SubmittedComment, FeedItemComment  } from 'types/comments';

export const UpdateLikeStatus = (item:ILikeable, status: boolean) => {
  return http.post(`/likes/update`, { ...item, status });
};